/**
 * Tutor certification form section.
 * 360 Learning certificate upload plus attestation number and obtention date.
 */
import * as React from 'react';
import { Award } from 'lucide-react';
import { Input } from '@/components/forms/Input';
import { DatePicker } from '@/components/forms/DatePicker';
import { FileDropzone } from '@/components/common/FileDropzone';
import { TUTOR_CERT_UPLOAD_CONFIG } from '@/components/tutors/tutor-configs';
import { defaultUpload, fileNameFromUrl } from '@/components/tutors/inperson/tutor-form-utils';

/** Props for {@link TutorCertificationSection}. */
interface Props {
  formData: Record<string, any>;
  set: (field: string, value: any) => void;
  onFileSelect?: (key: string, file: File | null) => void;
}

/** Tutor certification form section. */
export function TutorCertificationSection({ formData, set, onFileSelect }: Readonly<Props>) {
  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <Award className="w-4 h-4" />
        Certification 360 Learning
      </h4>
      <FileDropzone
        label="Certificat 360 Learning"
        accept={TUTOR_CERT_UPLOAD_CONFIG.accept}
        maxSize={TUTOR_CERT_UPLOAD_CONFIG.maxSize}
        uploadFn={onFileSelect ? undefined : defaultUpload}
        onFileSelect={onFileSelect ? (file) => onFileSelect('certFile', file) : undefined}
        value={formData.certDocumentLink ?? ''}
        onChange={(url) => {
          set('certDocumentLink', url);
          if (url) set('certDocumentName', fileNameFromUrl(url));
        }}
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Input
          label="Numéro d'attestation"
          placeholder="Ex: CERT-2026-001"
          value={formData.attestationNumber ?? ''}
          onChange={(e) => set('attestationNumber', e.target.value)}
          inputSize="sm"
        />
        <DatePicker
          label="Date d'obtention"
          placeholder="JJ/MM/AAAA"
          value={formData.obtentionDate ?? ''}
          onChange={(val) => set('obtentionDate', val)}
          inputSize="sm"
        />
      </div>
    </div>
  );
}
